import { render, staticRenderFns } from "./dashboardIframeQuickSight.vue?vue&type=template&id=4f39d994&"
import script from "./dashboardIframeQuickSight.vue?vue&type=script&lang=js&"
export * from "./dashboardIframeQuickSight.vue?vue&type=script&lang=js&"
import style0 from "./dashboardIframeQuickSight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports